module.exports = {"addButton":"+ pridať novú skupinu","newGroupName":"Nová skupina","getError":"Pri načítavaní skupín došlo k chybe"}